module.exports = __webpack_public_path__ + "static/fipcballerina-4c229ce53995ccc6d26270856fce2e24.jpeg";